var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorsCampusMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 40,
    viewBox: "0 0 209 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 209,
    height: 40,
    rx: 8,
    fill: "#E4E4EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 177,
    y: 12,
    width: 16,
    height: 16,
    rx: 6,
    fill: "#F2F2F5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 16,
    height: 16,
    rx: 6,
    fill: "#F2F2F5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 14,
    width: 87,
    height: 12,
    rx: 6,
    fill: "#F2F2F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorsCampusMap);
export default __webpack_public_path__ + "static/media/floors_campus_map.d27c86b3d9430132b62b2b4f2f7b411e.svg";
export { ForwardRef as ReactComponent };